import React from 'react'

import { EllipsisIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import CompactGroupByPicker from '~/client/src/shared/components/CompactGroupByPicker/CompactGroupByFilter'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import { WorkflowList } from '~/client/src/shared/components/WorkflowList'
import LogisticsGroupingOption, {
  getLogisticsGroupingOptionTranslatorKey,
} from '~/client/src/shared/enums/LogisticsGroupingOption'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'
import TagsStore from '~/client/src/shared/stores/domain/Tags.store'
import UserProjectsStore from '~/client/src/shared/stores/domain/UserProjects.store'
import { toWorkflowGroupingKey } from '~/client/src/shared/utils/logisticsHelper'

import MobileInitialState from '../../../../stores/MobileInitialState'
import MobileLogisticsStore from '../../stores/MobileLogistics.store'
import MobileLogisticsFilterStore from '../../stores/MobileLogisticsFilter.store'
import MobileLogisticsGroupingOptionsStore from '../../stores/MobileLogisticsGroupingOptions.store'
import MobileLogisticsListStore from '../../stores/MobileLogisticsList.store'
import CompactLogisticsFilter from '../CompactLogsiticsFilter/CompactLogisticsFilter'
import LogisticsFilters from '../LogisticsFilters/LogisticsFilters'

interface IProps {
  state?: MobileInitialState
  companiesStore?: CompaniesStore
  store: MobileLogisticsStore
  logisticsListStore: MobileLogisticsListStore
  logisticsFilterStore: MobileLogisticsFilterStore
  userProjectsStore?: UserProjectsStore
  projectMembersStore?: ProjectMembersStore
  tagsStore?: TagsStore
}

@inject(
  'state',
  'companiesStore',
  'userProjectsStore',
  'projectMembersStore',
  'tagsStore',
)
@observer
export default class MobileLogisticsList extends React.Component<IProps> {
  private readonly logisticsGroupingOptionsStore: MobileLogisticsGroupingOptionsStore =
    null

  public constructor(props: IProps) {
    super(props)

    this.logisticsGroupingOptionsStore =
      new MobileLogisticsGroupingOptionsStore(
        getLogisticsGroupingOptionTranslatorKey,
      )
  }

  public render() {
    const { logisticsFilterStore, logisticsListStore } = this.props
    const {
      groupingKey,
      toggleFilters,
      toggleGroupBy,
      isFiltersModalOpen,
      isGroupByFilterShown,
    } = logisticsListStore

    return (
      <div className="logistics-list bg-white full-height">
        <div className="body-header row full-width sticky z-index-5 bg-white">
          <LogisticsFilters
            companiesStore={this.props.companiesStore}
            logisticsStore={this.props.store}
            toggleFilters={this.props.logisticsListStore.toggleFilters}
            logisticsFilterStore={logisticsFilterStore}
            state={this.props.state}
            userProjectsStore={this.props.userProjectsStore}
            selectedOptionsCount={logisticsFilterStore.selectedOptionsCount}
          />
        </div>
        <div className="col items-list relative full-height">
          {this.props.store.workflowsLoading && (
            <div
              className="absolute full-width full-height row x-center y-center z-index-100"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
            >
              <Spinner />
            </div>
          )}
          <WorkflowList
            workflows={logisticsListStore.workflowPermits}
            loading={this.props.store.workflowsLoading}
            isReadOnly={true}
            onWorkflowClick={logisticsListStore.onPermitClick}
            groupingKey={toWorkflowGroupingKey(logisticsListStore.groupingKey)}
            toolbarExtra={this.renderGroupByButton()}
            cardListClassName="tw:pb-[50px]"
          />
        </div>
        <CompactLogisticsFilter
          store={this.props.logisticsFilterStore}
          onClose={toggleFilters}
          isShown={isFiltersModalOpen}
          selectedOptionsCount={logisticsFilterStore.selectedOptionsCount}
          companiesStore={this.props.companiesStore}
          projectMembersStore={this.props.projectMembersStore}
          tagsStore={this.props.tagsStore}
        />
        <CompactGroupByPicker
          isShown={isGroupByFilterShown}
          selectedMode={groupingKey}
          onHide={toggleGroupBy}
          onGroupByChange={this.onGroupByChange}
          groupByOptions={this.logisticsGroupingOptionsStore.groupByOptions}
        />
      </div>
    )
  }

  private onGroupByChange = (bandType: LogisticsGroupingOption) => {
    const { toggleGroupBy, selectGroupBy } = this.props.logisticsListStore
    selectGroupBy(bandType)
    toggleGroupBy()
  }

  private renderGroupByButton() {
    return (
      <Button
        variant="ghost"
        size="icon-sm"
        className="tw:flex-none! tw:ml-auto tw:mr-[15px]"
        aria-label={Localization.translator.groupBy}
        onClick={() => this.props.logisticsListStore.toggleGroupBy()}
      >
        <EllipsisIcon />
      </Button>
    )
  }
}
